import React from 'react';
import _ from 'lodash';
import { PropTypes } from 'prop-types';

const DropdownMenu = ({
    name,
    label,
    options,
    activeOptions,
    onClickOption
}) => {
    if (options.length === 0) {
        return null;
    }

    const opt = options.map(o => {
        let className = 'option';
        if (_.find(activeOptions, a => a.slug === o.slug)) {
            className += ' active';
        }

        return (
            <div
                key={o.slug}
                className={className}
                onClick={() => onClickOption(name, o)}
            >
                <span dangerouslySetInnerHTML={{ __html: o.name }} />
            </div>
        );
    });

    let classList = ['dropdown-menu', name];

    return (
        <div className={classList.join(' ')}>
            <button className="dropdown-label">
                <span
                    className="name"
                    dangerouslySetInnerHTML={{ __html: label }}
                />
                <i className="caret" />
            </button>
            <div className="options">{opt}</div>
        </div>
    );
};

DropdownMenu.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    options: PropTypes.array,
    activeOptions: PropTypes.array,
    onClickOption: PropTypes.func.isRequired
};

export default DropdownMenu;
